var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.996,
    viewBox: "0 0 20 19.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9634",
    "data-name": "Trac\\xE9 9634",
    d: "M19.117.881a3.022,3.022,0,0,0-4.27,0L0,15.725v4.269H4.27L19.117,5.151A3.021,3.021,0,0,0,19.117.881ZM17.939,3.973,15.849,6.061,13.937,4.145,16.025,2.06a1.355,1.355,0,0,1,1.917,1.916h0Z",
    transform: "translate(0 0.002)",
    fill: "#cbc9c9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/iconEdit.9d8570825b894153b8f50b29db45d18a.svg";
export { ForwardRef as ReactComponent };